module.exports = __webpack_public_path__ + "icons/original/small/small-b1.376d5df50dd14a86919d705382c89060.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-b1.png
// module id = 27d+
// module chunks = app